export default "__VITE_ASSET__Cmjeq9cP__"